/*
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2022-10-08 15:32:08
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2023-04-03 11:32:41
 * @FilePath: \xm-runing-main\src\utils\xmCom\loadSystem.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {getUrlParams, StorageUtils} from 'xmgoing-utils';
import { useUserStore } from '@/store/modules/user';
import {LOCALE_KEY, TOKEN_KEY} from "@/enums/cacheEnum";
import {setAuthCache} from "@/utils/auth";
import {createLocalStorage} from "@/utils/cache";
import sysConfigUtils from "@/utils/sysConfigUtils";
import {loadCurSystemConfig} from "@/utils/CurSystemConfigUtils";
import {dbUtils} from "xmgoing-utils";
import {loadSystemSessionCache} from "@/utils/xmCom/curSystemCachUtils";
import GoingUtils from "@/utils/goingUtils";

//登出系统
export function loadOutSystem(outPrams={},isClearUser=true) {
  const loginUserType=StorageUtils.getSessionItem("loginUserType");
  const pageType=StorageUtils.getSessionItem("pageType");
  const projectI18nVal=StorageUtils.getSessionItem("projectI18n");

  StorageUtils.removeSessionItem("curHref");
  StorageUtils.removeItem("curHref");
  //清空缓存 退出系统
  isClearUser && dbUtils.clearSessionItems();
  isClearUser && dbUtils.clearCurUserInfo();
  nextTick(()=>{
    const paramsUrl:any=[];
    //界面类型
    if(pageType){
      paramsUrl.push(`pageType=`+pageType);
    }
    //如果是系统产品超期
    if(outPrams.timeOut){
      paramsUrl.push(`timeOut=true`);
    }
    const ls = createLocalStorage();
    const locale = projectI18nVal||(ls.get(LOCALE_KEY)&&ls.get(LOCALE_KEY).locale)||StorageUtils.getItem("projectI18n") || 'zh-CN'
    paramsUrl.push(`locale=`+locale);
    const Url = new URL('/login/', sysConfigUtils.getAppRunningLoginUrl(StorageUtils.getItem('outSystemPortal')));
    let path = ''
    // if(window.appObj.tenantId){
    //   if('000000'===(window.appObj.tenantId+'')){
    //     path = `/login`
    //   }else{
    //     path = `/loginAccount/${window.appObj.tenantId}`
    //   }
    // }else{
    //   path = `/login`
    // }
    //如果是运营登录 则跳转到运营登录界面
    if((loginUserType)==='operateUser'){
      path = `/operateLogin`
    }
    const Hash = new URL(path, sysConfigUtils.getAppRunningLoginUrl(StorageUtils.getItem('outSystemPortal')))
    Hash.search = paramsUrl.join("&")
    const hash = Hash.toString().replace(Hash.origin, '')
    Url.hash = hash;
    location.href = Url.toString();
  })
}

/**
 * 获取当前时间
 */
export function getCurDate() {
  const date = new Date();
  const year = date.getFullYear();    //  返回的是年份
  let month:any = date.getMonth() + 1;  //  返回的月份上个月的月份，记得+1才是当月
  let dates:any = date.getDate();       //  返回的是几号
  if (parseInt(month) < 10) {
    month = "0" + month;
  }
  if (parseInt(dates) < 10) {
    dates = "0" + dates;
  }
  return year + "-" + month + "-" + dates;
}

export function DateDiffGetDateDiff(startTime, endTime, diffType) {
  //将xxxx-xx-xx的时间格式，转换为 xxxx/xx/xx的格式
  startTime = startTime.replace(/-/g, "/");
  endTime = endTime.replace(/-/g, "/");
  //将计算间隔类性字符转换为小写
  diffType = diffType.toLowerCase();
  let sTime = new Date(startTime);      //开始时间
  let eTime = new Date(endTime);  //结束时间
  //作为除数的数字
  let divNum = 1;
  switch (diffType) {
    case "second":
      divNum = 1000;
      break;
    case "minute":
      divNum = 1000 * 60;
      break;
    case "hour":
      divNum = 1000 * 3600;
      break;
    case "day":
      divNum = 1000 * 3600 * 24;
      break;
    default:
      break;
  }
  return parseInt((eTime.getTime() - sTime.getTime()) / parseInt(divNum));
}

/**
 * 获取当前的用户信息
 */
export async function loadUserInfo(backFun)  {
  const userStore = useUserStore();
  const sessionIdStr: any = StorageUtils.getSessionItem('sessionId');
  userStore.setToken(sessionIdStr);
  userStore.afterLoginAction(backFun);
}

//登陆系统
export async function loadSystem(res={}) {
  const {
    href,
  } = location;
  if(href.indexOf("/static")>=0){
    return
  }
  //登录后进行缓存
  loadSystemSessionCache(res);
  const loginPortal=getUrlParams("loginPortal",true);
  if(loginPortal){
    setTimeout(()=>{
      window.appObj.loginPortal=loginPortal;
    },300)
  }
  let sessionId = (res as any).access_token||getUrlParams('sessionId', true);
  // 仅新登录（URL 中的 sessionId 与缓存不一致）时清布局缓存；
  // 普通刷新 URL 仍可能带 sessionId，不能清，否则刚保存的框架配置会丢、回退到旧主题
  const urlSessionId = getUrlParams('sessionId', true);
  if (urlSessionId) {
    const cachedSessionId = StorageUtils.getSessionItem('sessionId');
    if (!cachedSessionId || cachedSessionId !== urlSessionId) {
      StorageUtils.removeSessionItem('defaultLayoutConfig');
      StorageUtils.removeSessionItem('systemConfig');
      StorageUtils.removeSessionItem('xm_preferred_layout');
    }
  }
  //如果是门户框架设计 则存在历史sessionId 则用历史的即可
  if(window.sessionStorage.getItem("analysisSetFlag")==='analysisSetFlag'){
    sessionId=StorageUtils.getSessionItem('sessionId')||sessionId;
  }
  const projectI18n=getUrlParams("projectI18n",true);
  const ls = createLocalStorage();
  if(projectI18n){
    if(projectI18n==='en-US'){
      StorageUtils.addSessionItem("projectI18n","en");
      ls.set(LOCALE_KEY, "en");
    }else{
      StorageUtils.addSessionItem("projectI18n","zh-CN");
      ls.set(LOCALE_KEY, "zh-CN");
    }
  }else{
    if(ls.get(LOCALE_KEY)&&ls.get(LOCALE_KEY).locale){
      StorageUtils.addSessionItem("projectI18n",ls.get(LOCALE_KEY).locale);
    }
  }
  if (!sessionId) {
    sessionId = StorageUtils.getSessionItem('sessionId');
  }
  //清空历史值对当前对影响
  StorageUtils.addSessionItem("showApp","false");
  //如果存在sessionId 则存到缓存中去
  if (sessionId) {
    StorageUtils.addSessionItem('sessionId', sessionId);
  }
  //缓存userId
  let userId = (res as any).user_id||getUrlParams('userId', true)
  if (!userId) {
    userId = StorageUtils.getSessionItem('userId');
  }
  if (userId) {
    StorageUtils.addSessionItem('userId', userId);
  }
  //设置token信息
  setAuthCache(TOKEN_KEY, sessionId);
  //校验sessionId是否存在 如果不存在 跳回到登陆
  if (!sessionId) {
    loadOutSystem();
  }
  loadCurSystemConfig();
  GoingUtils.loadSystemDateVaildate();
}
